import * as z from "zod";
//#region src/__generated__/filesystem-gge/documents/zod/abstractDeleteResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const abstractDeleteResponseSchema = z.object({ filename: z.string().nullish() });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/delete7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const delete7PathIdSchema = z.uuid();
const delete7Status200Schema = z.array(abstractDeleteResponseSchema);
const delete7ResponseSchema = delete7Status200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/deleteFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteFileMetasRequestDtoSchema = z.object({
	ids: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }),
	initUserId: z.uuid()
});
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/deleteMany7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteMany7Status200Schema = z.array(z.string());
const deleteMany7ResponseSchema = deleteMany7Status200Schema;
const deleteMany7DataSchema = deleteFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/fileMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSchema = z.object({
	author: z.uuid(),
	baseName: z.string(),
	createdAt: z.union([z.number(), z.iso.datetime()]),
	ext: z.string().nullish(),
	id: z.uuid(),
	isDeleted: z.boolean(),
	modifiedAt: z.union([z.number(), z.iso.datetime()]),
	parentId: z.uuid().nullish(),
	preview: z.string().nullish().describe("Файл preview закодированный в base64. Поле может быть null, если для данного элемента не поддерживаются preview либо, если для данного элемента preview еще не было получено/сконвертировано."),
	previewId: z.uuid().nullish(),
	size: z.int(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"KNOWLEDGE_BASE",
		"REPORT_GENERATION_CACHE"
	]),
	type: z.enum([
		"DIRECTORY",
		"DOCUMENT",
		"CLASSIFIER_DOCUMENT",
		"MODEL",
		"MODEL_DATA",
		"MODEL_DATA_SIMPLIFIED",
		"IMAGE",
		"COMMENT_DOCUMENT",
		"COSMOS_DOCUMENT",
		"COSMOS_GEOSERVER_DOCUMENT",
		"BUILDING_MANAGEMENT_DOCUMENT",
		"TASK_TRACKER",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"ONTOLOGY_DOCUMENT",
		"COLLISION_DOCUMENT",
		"KNOWLEDGE_BASE_DOCUMENT",
		"REPORT_GENERATION_CACHE",
		"PDF_DOCUMENT",
		"PDF_DOCUMENT_PREVIEW"
	]),
	version: z.int(),
	versionParentId: z.uuid().nullish().describe("Id первой версии этого файла. Присутствует только если поле version > 1")
});
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/getFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/getFileMetas7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getFileMetas7Status200Schema = z.array(fileMetaDtoSchema);
const getFileMetas7ResponseSchema = getFileMetas7Status200Schema;
const getFileMetas7DataSchema = getFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/getLatestFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getLatestFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/getLatestFileMetas7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getLatestFileMetas7Status200Schema = z.array(fileMetaDtoSchema);
const getLatestFileMetas7ResponseSchema = getLatestFileMetas7Status200Schema;
const getLatestFileMetas7DataSchema = getLatestFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/documentListResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const documentListResponseSchema = z.object({ fileMeta: z.union([fileMetaDtoSchema, z.null()]).optional() });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/list7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const list7PathIdSchema = z.uuid();
const list7Status200Schema = z.array(documentListResponseSchema);
const list7ResponseSchema = list7Status200Schema;
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/documentMoveResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const documentMoveResponseSchema = z.object({ moveCnt: z.int().nullish() });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/fileMoveDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMoveDtoSchema = z.object({
	id: z.uuid(),
	parentId: z.uuid()
}).describe("Move модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/move5Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const move5Status200Schema = z.array(documentMoveResponseSchema);
const move5ResponseSchema = move5Status200Schema;
const move5DataSchema = fileMoveDtoSchema.describe("Move модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/documentRenameResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const documentRenameResponseSchema = z.object({ fileMeta: z.union([fileMetaDtoSchema, z.null()]).optional() });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/fileRenameDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileRenameDtoSchema = z.object({
	id: z.uuid(),
	newName: z.string()
}).describe("Rename модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/rename7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const rename7Status200Schema = documentRenameResponseSchema;
const rename7ResponseSchema = rename7Status200Schema;
const rename7DataSchema = fileRenameDtoSchema.describe("Rename модель для файла.");
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/resolveLatestFileMetasRequestDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resolveLatestFileMetasRequestDtoSchema = z.object({ ids: z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }) });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/resolveLatestFileMetas7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const resolveLatestFileMetas7Status200Schema = z.array(fileMetaDtoSchema);
const resolveLatestFileMetas7ResponseSchema = resolveLatestFileMetas7Status200Schema;
const resolveLatestFileMetas7DataSchema = resolveLatestFileMetasRequestDtoSchema;
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/documentUpdateResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const documentUpdateResponseSchema = z.object({ fileMeta: fileMetaDtoSchema });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/update7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const update7QueryProcessTaskSchema = z.enum([
	"CLASSIFIER_DATA",
	"DICTIONARY_DATA",
	"DOCUMENT",
	"DICTIONARY_CALC_COST",
	"DICTIONARY_CALC_CALENDAR",
	"BUILDING_MANAGEMENT",
	"KNOWLEDGE_BASE_DOCUMENT",
	"TASK_TRACKER_DEFAULT"
]).optional();
const update7Status200Schema = documentUpdateResponseSchema;
const update7ResponseSchema = update7Status200Schema;
const update7DataSchema = z.object({
	document: z.instanceof(File),
	id: z.string()
}).optional();
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/documentUploadResponseSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const documentUploadResponseSchema = z.object({ fileMeta: fileMetaDtoSchema });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/upload7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const upload7QueryProcessTaskSchema = z.enum([
	"CLASSIFIER_DATA",
	"DICTIONARY_DATA",
	"DOCUMENT",
	"DICTIONARY_CALC_COST",
	"DICTIONARY_CALC_CALENDAR",
	"BUILDING_MANAGEMENT",
	"KNOWLEDGE_BASE_DOCUMENT",
	"TASK_TRACKER_DEFAULT"
]).optional();
const upload7Status200Schema = documentUploadResponseSchema;
const upload7ResponseSchema = upload7Status200Schema;
const upload7DataSchema = z.object({
	document: z.instanceof(File),
	parentId: z.string(),
	sourceId: z.string(),
	sourceType: z.string()
}).optional();
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/uploadFilesAsZipResponseDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const uploadFilesAsZipResponseDtoSchema = z.object({ fileMetaDtos: z.array(fileMetaDtoSchema) });
//#endregion
//#region src/__generated__/filesystem-gge/documents/zod/uploadZip7Schema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const uploadZip7Status200Schema = uploadFilesAsZipResponseDtoSchema;
const uploadZip7ResponseSchema = uploadZip7Status200Schema;
const uploadZip7DataSchema = z.object({
	document: z.instanceof(File),
	parentId: z.string(),
	sourceId: z.string(),
	sourceType: z.string()
}).optional();
//#endregion
export { list7ResponseSchema as A, getFileMetasRequestDtoSchema as B, documentRenameResponseSchema as C, fileMoveDtoSchema as D, move5Status200Schema as E, getLatestFileMetas7Status200Schema as F, deleteFileMetasRequestDtoSchema as G, deleteMany7DataSchema as H, getLatestFileMetasRequestDtoSchema as I, delete7Status200Schema as J, delete7PathIdSchema as K, getFileMetas7DataSchema as L, documentListResponseSchema as M, getLatestFileMetas7DataSchema as N, documentMoveResponseSchema as O, getLatestFileMetas7ResponseSchema as P, getFileMetas7ResponseSchema as R, fileRenameDtoSchema as S, move5ResponseSchema as T, deleteMany7ResponseSchema as U, fileMetaDtoSchema as V, deleteMany7Status200Schema as W, abstractDeleteResponseSchema as Y, resolveLatestFileMetas7Status200Schema as _, upload7DataSchema as a, rename7ResponseSchema as b, upload7Status200Schema as c, update7QueryProcessTaskSchema as d, update7ResponseSchema as f, resolveLatestFileMetas7ResponseSchema as g, resolveLatestFileMetas7DataSchema as h, uploadFilesAsZipResponseDtoSchema as i, list7Status200Schema as j, list7PathIdSchema as k, documentUploadResponseSchema as l, documentUpdateResponseSchema as m, uploadZip7ResponseSchema as n, upload7QueryProcessTaskSchema as o, update7Status200Schema as p, delete7ResponseSchema as q, uploadZip7Status200Schema as r, upload7ResponseSchema as s, uploadZip7DataSchema as t, update7DataSchema as u, resolveLatestFileMetasRequestDtoSchema as v, move5DataSchema as w, rename7Status200Schema as x, rename7DataSchema as y, getFileMetas7Status200Schema as z };

//# sourceMappingURL=uploadZip7Schema2.js.map